import { lazy } from "react";
import ErrorPage from "../../components/UI/ErrorPage";
import UserRouteGuard from "../RouteGuards/UserRouteGuard";

import { assetRoutes } from "./assets/assets.routes";
import { profileRoutes } from "./profile/profile.routes";
import { purchaseRoutes } from "./purchase/purchase.routes";
import { salesRoutes } from "./sales/sales.routes";
import { notificationRoutes } from "./notifications/notifications.routes";
import { transactionRoutes } from "./transaction/transactions.routes";
import { walletRoutes } from "./wallet/wallet.routes";
// Common
 import UserDashboard from"../../pages/User/UserDashboard";
// const UserDashboard = lazy(() => import("../../pages/User/UserDashboard"));
const Main = lazy(() => import("../../pages/User/Home"));
const NotFoundPage = lazy(() => import("../../pages/404"));

export const userRoutes = [
  {
    path: "/user/my-dashboard",
    element: <UserRouteGuard element={<UserDashboard />} />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <Main /> },
      ...profileRoutes,
      ...assetRoutes,
      ...purchaseRoutes,
      ...salesRoutes,
      ...transactionRoutes,
      ...notificationRoutes,
      ...walletRoutes,

      // Fallback
      { path: "*", element: <NotFoundPage /> },
    ],
  },
];


